import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ROUTES } from './utils/routes';
import { AuthGuard } from './modules/auth/auth.guard';
import { MaintenanceGuard } from './modules/auth/maintenance.guard';

const routes: Routes = [
  { path: '', redirectTo: ROUTES.LOGIN, pathMatch: 'full' },
  {
    path: '',
    canActivate: [MaintenanceGuard],
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  { path: 'set-password', redirectTo: ROUTES.SET_PASSWORD, pathMatch: 'full' },
  { path: 'forgot-password', redirectTo: ROUTES.FORGOT_PASSWORD, pathMatch: 'full' },
  { path: 'confirm-email', redirectTo: ROUTES.CONFIRM_EMAIL, pathMatch: 'full' },
  { path: 'home', canActivate: [MaintenanceGuard, AuthGuard], loadChildren: () => import('./modules/layout/layout.module').then(m => m.LayoutModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
